import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPreviewOff$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPreviewOff extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '72100a18e9966a27953214c4d3b82e65533afea9', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'dd85f170b36f8bc7e1fa5c792d6e86d40d4acca6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '952e4730fc73c13ed77638f1a129f36ecae4db10', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.227 3.146a.527.527 0 0 1 .728 0l3.414 3.36a9.5 9.5 0 0 1 2.622-.358c3.554 0 6.471 1.813 8.806 5.19.27.43.27.974 0 1.404l-.013.019c-.705 1.048-1.482 1.947-2.326 2.688l2.355 2.318c.2.202.2.524 0 .727l-.364.359a.537.537 0 0 1-.74 0L3.852 4.233a.506.506 0 0 1 0-.718zM16.35 14.36c.734-.63 1.415-1.406 2.043-2.319-2.028-2.871-4.462-4.356-7.403-4.356q-.677 0-1.317.105l1.459 1.435c1.468.07 2.646 1.23 2.718 2.675zM5.031 8.24c-1.02.804-1.955 1.833-2.808 3.073a1.3 1.3 0 0 0-.007 1.445c2.252 3.346 5.205 5.173 8.775 5.173a9.5 9.5 0 0 0 3.305-.574l-1.243-1.223a8 8 0 0 1-2.062.26c-2.957 0-5.418-1.495-7.383-4.352q1.17-1.671 2.535-2.708zm3.179 3.128q-.082.323-.082.672c0 1.556 1.282 2.818 2.863 2.818q.355-.001.684-.08z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-preview-off", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-preview-off"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-preview-off":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPreviewOff$1);
            }
            break;
    } });
}

const CosmosIconPreviewOff = CosmosIconPreviewOff$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPreviewOff, defineCustomElement };
